import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AssignmentPage() {
  const navigate = useNavigate();

  const initialParticipants = [
    { name: "", role: "" },
    { name: "", role: "" }
  ];

  const [participants, setParticipants] = useState(initialParticipants);
  const [results, setResults] = useState([]);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');

  const resetAll = () => {
    setParticipants(initialParticipants);
    setResults([]);
  };

  const addParticipant = () => {
    setParticipants([...participants, { name: "", role: "" }]);
  };

  const removeParticipant = () => {
    if (participants.length <= 2) return;
    setParticipants(participants.slice(0, -1));
  };

  const assignRoles = () => {
    const validList = participants.filter(p => p.name.trim() !== "" && p.role.trim() !== "");

    if (validList.length === 0) {
      setAlertMsg("이름과 역할을 최소 1개 이상 입력해야 합니다!");
      setShowAlertModal(true);
      return;
    }

    const shuffledRoles = [...validList.map(p => p.role)].sort(() => Math.random() - 0.5);
    const newResults = validList.map((p, idx) => ({
      userName: p.name,
      roleName: shuffledRoles[idx]
    }));
    setResults(newResults);
  };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate(-1)} style={backBtn}>← 이전으로</button>
      <h2 style={titleStyle}>👥 랜덤 역할 할당</h2>

      <div style={gridStyle}>
        {/* 이름 컬럼 */}
        <div>
          <h3 style={subtitleStyle}>참여자 이름</h3>
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '8px',
            maxHeight: participants.length >= 6 ? '280px' : 'none',
            overflowY: participants.length >= 6 ? 'auto' : 'visible',
            paddingRight: participants.length >= 6 ? '4px' : '0',
          }}>
            {participants.map((p, i) => (
              <input
                key={i}
                value={p.name}
                onChange={(e) => {
                  const updated = [...participants];
                  updated[i].name = e.target.value;
                  setParticipants(updated);
                }}
                style={inputStyle}
                placeholder={`이름 ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* 역할 컬럼 */}
        <div>
          <h3 style={subtitleStyle}>분배할 역할</h3>
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '8px',
            maxHeight: participants.length >= 6 ? '280px' : 'none',
            overflowY: participants.length >= 6 ? 'auto' : 'visible',
            paddingRight: participants.length >= 6 ? '4px' : '0',
          }}>
            {participants.map((p, i) => (
              <input
                key={i}
                value={p.role}
                onChange={(e) => {
                  const updated = [...participants];
                  updated[i].role = e.target.value;
                  setParticipants(updated);
                }}
                style={inputStyle}
                placeholder={`역할 ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ✅ 버튼 그룹: 참여자 +, 참여자 -, 랜덤 할당 시작, 초기화 */}
      <div style={buttonGroup}>
        <button onClick={addParticipant} style={utilBtn}>참여자 +</button>
        <button onClick={removeParticipant} style={utilBtn}>참여자 -</button>
        <button onClick={assignRoles} style={assignBtn}>랜덤 할당 시작!</button>
        <button onClick={resetAll} style={resetBtn}>♻️ 초기화</button>
      </div>

      {results.length > 0 && (
        <div style={resultBox}>
          <h3 style={{marginBottom: '15px'}}>✨ 할당 결과</h3>
          <table style={tableStyle}>
            <thead>
              <tr style={{borderBottom: '2px solid #E2E8F0'}}>
                <th style={{padding: '10px'}}>이름</th>
                <th style={{padding: '10px'}}>할당된 역할</th>
              </tr>
            </thead>
            <tbody>
              {results.map((res, idx) => (
                <tr key={idx} style={{borderBottom: '1px solid #F1F5F9'}}>
                  <td style={{padding: '12px'}}>{res.userName}</td>
                  <td style={{padding: '12px', color: '#4F46E5', fontWeight: 'bold'}}>{res.roleName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showAlertModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={modalTitleStyle}>{alertMsg}</h3>
            <div style={modalButtonContainerStyle}>
              <button style={modalConfirmButtonStyle} onClick={() => setShowAlertModal(false)}>확인</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const containerStyle = {
  maxWidth: '800px', margin: '0 auto', padding: '60px 20px 80px',
  minHeight: '100vh', boxSizing: 'border-box',
  fontFamily: 'Pretendard, sans-serif'
};
const backBtn = { padding: '10px 20px', background: '#fff', border: '1px solid #E2E8F0', borderRadius: '10px', cursor: 'pointer', marginBottom: '20px', fontWeight: '600' };
const titleStyle = { textAlign: 'center', marginBottom: '30px', fontWeight: '800' };
const subtitleStyle = { fontSize: '18px', marginBottom: '10px' };
const gridStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '20px' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #E2E8F0', outline: 'none', boxSizing: 'border-box' };
const buttonGroup = { display: 'grid', gridTemplateColumns: '1fr 1fr 2fr 1fr', gap: '10px', marginTop: '20px' };
const utilBtn = { padding: '16px', background: '#fff', border: '1px solid #E2E8F0', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' };
const assignBtn = { padding: '16px', background: '#000', color: '#fff', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', border: 'none', cursor: 'pointer' };
const resetBtn = { padding: '16px', background: '#fff', color: '#64748B', border: '1px solid #E2E8F0', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer' };
const resultBox = { marginTop: '40px', padding: '30px', background: '#fff', borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', border: '1px solid #E2E8F0' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', textAlign: 'center' };
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 };
const modalContentStyle = { backgroundColor: '#fff', padding: '30px 40px', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center', minWidth: '320px' };
const modalTitleStyle = { fontSize: '18px', fontWeight: '600', color: '#333', margin: '0 0 25px 0' };
const modalButtonContainerStyle = { display: 'flex', justifyContent: 'center', gap: '12px' };
const modalConfirmButtonStyle = { padding: '10px 20px', border: 'none', backgroundColor: '#4A90E2', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', width: '100%' };

export default AssignmentPage;